import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LoadingSpinnerComponent } from './components/loading-spinner/loading-spinner.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component'
@NgModule({
  declarations: [
    LoadingSpinnerComponent,
    FileUploadComponent
  ],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [
    LoadingSpinnerComponent,
    FileUploadComponent
  ]
})
export class SharedModule { }
